import { Outlet, createFileRoute } from '@tanstack/react-router';
import { VStack } from '@/components/Layout';
import { LicenseProfileHeader } from './_profile/-components/LicenseProfileHeader';
export const Route = createFileRoute('/_staff/licenses/$id/_profile')({
  component: LicenseProfile
});
function LicenseProfile() {
  return <VStack>
      <LicenseProfileHeader />
      <Outlet />
    </VStack>;
}